<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
        <img class="zero" src="../assets/index/Oval.png" v-show="zeroShow" :style="{top: zeroTop, left: zeroLeft}" />
        <div class="tips">
            <div class="tip-box" v-for="item in level" :key="item.color">
                <div class="color" :style="{background: item.color}"></div>
                <!-- <div class="text" v-if="item.max">≤{{item.max}}</div>
                <div class="text" v-else>>={{item.min}}</div> -->
                <div class="text">≥{{item.min}}{{showUnit ? unit : ''}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import JSON from '../assets/home/yunnan.json';

    export default {
        name: 'mapCharts',
        props: {
            list: Array,
            level: Array,
            showCircle: Boolean,
            unit: {
                type: String,
                default: '名'
            },
            showUnit: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                zeroTop: 0,
                zeroLeft: 0,
                zeroShow: false,
                option: {
                    tooltip: {
                        trigger: 'item',
                        triggerOn: 'mousemove',
                        formatter: params => {
                            return `${params.data.cityShortName || params.data.name}  ${params.data.value}${this.unit}`;
                        }
                    },
                    visualMap: {
                        show: false,
                        pieces: [],
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: '#fff',
                            borderWidth: 5,
                            areaStyle: { color: 'rgba(54,179,116,0.1)' }
                        }
                    },
                    series: [{
                        name: '重点关注总量',
                        type: 'map',
                        mapType: 'yunnan', // 自定义扩展图表类型
                        aspectScale: 1,
                        itemStyle: {
                            normal: { label: { show: false } },
                            emphasis: { label: { show: false } }
                        },
                        data: []
                    }]
                }
            };
        },
        mounted () {
            console.log('document.body.clientWidth:', document.body.clientWidth)
            this.echartObj = echarts.init(document.getElementById(this.id));
            echarts.registerMap('yunnan', JSON);
            this.echartObj.setOption(this.setSeriesData(), true);
            this.echartObj.on('click', 'series.map', (params) => {
                // console.log(params.event.offsetX)
                // console.log(params.event.offsetY)
                this.tapMap = true
                switch (params.data.cityShortName) {
                case '怒江':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(63.0249537620614)
                    this.zeroLeft = this.getPercent(104.200012207032)
                    break;
                case '迪庆':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(31.024958644873006)
                    this.zeroLeft = this.getPercent(115.4000015258797)
                    break;
                case '丽江':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(54.224967311863935)
                    this.zeroLeft = this.getPercent(141.000000000001)
                    break;
                case '大理':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(80.6250487327501)
                    this.zeroLeft = this.getPercent(127.40000915527439)
                    break;
                case '保山':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(100.62504568099293)
                    this.zeroLeft = this.getPercent(103.4000015258797)
                    break;
                case '临沧':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(127.02494399643824)
                    this.zeroLeft = this.getPercent(120.2000122070322)
                    break;
                case '德宏':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(110.22495876694377)
                    this.zeroLeft = this.getPercent(81.80001831054751)
                    break;
                case '普洱':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(143.8249902610798)
                    this.zeroLeft = this.getPercent(145.80003356933713)
                    break;
                case '西双版纳':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(170.22494961167203)
                    this.zeroLeft = this.getPercent(149.80003356933722)
                    break;
                case '玉溪':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(124.62504201888416)
                    this.zeroLeft = this.getPercent(172.20001220703261)
                    break;
                case '红河':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(139.02494216538386)
                    this.zeroLeft = this.getPercent(198.60000610351725)
                    break;
                case '楚雄':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(90.22496181870083)
                    this.zeroLeft = this.getPercent(165.80003356933716)
                    break;
                case '昆明':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(90.22496181870079)
                    this.zeroLeft = this.getPercent(193.80003356933742)
                    break;
                case '昭通':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(33.42498269272066)
                    this.zeroLeft = this.getPercent(220.19999694824372)
                    break;
                case '曲靖':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(82.22496303940362)
                    this.zeroLeft = this.getPercent(220.19999694824386)
                    break;
                case '文山':
                    this.zeroShow = true
                    this.zeroTop = this.getPercentTop(131.8249920921339)
                    this.zeroLeft = this.getPercent(235.40000915527537)
                }
            })
            this.echartObj.on('mouseout', (params) => {
                this.zeroShow = false
            })
        },
        watch: {
            list: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            },
            zeroTop: {
                handler (newValue, oldValue) {
                    // console.log(newValue)
                }
            },
            zeroLeft: {
                handler (newValue, oldValue) {
                    // console.log(newValue)
                }
            },
            showCircle: {
                handler (newValue, oldValue) {
                    this.zeroShow = newValue
                }
            }
        },
        methods: {
            getPercent (num) {
                // let clientWidth = document.body.clientWidth
                let clientWidth = 375
                let padding = clientWidth * 0.032 * 2
                let finalWidth = clientWidth - padding
                console.log(Number((num / finalWidth) * 100).toFixed(2) + '%')
                return Number((num / finalWidth) * 100).toFixed(2) + '%'
            },
            getPercentTop (num) {
                // let clientWidth = document.body.clientWidth
                let clientWidth = 375
                let finalHeight = (clientWidth / 375) * 250
                console.log(Number((num / finalHeight) * 100).toFixed(2) + '%')
                return Number((num / finalHeight) * 100).toFixed(2) + '%'
            },
            getSeriesData () {
                // 填入省份及数据2
                if (this.list.length > 0) {
                    return this.list.map(item => {
                        return {
                            name: item.name,
                            value: item.value,
                            cityShortName: item.cityShortName
                        };
                    });
                } else {
                    return JSON.features.map(item => {
                        return {
                            name: item.properties.name,
                            value: Math.ceil(Math.random() * 100)
                        };
                    });
                }
            },
            getColor () {
                // 填入颜色及范围
                if (this.level.length > 0) {
                    return this.level.map(item => {
                        return {
                            min: item.min,
                            max: item.max,
                            color: item.color
                        };
                    });
                }
            },
            setSeriesData () {
                this.setOptions('series', (() => {
                    return {
                        name: '重点关注总量',
                        type: 'map',
                        mapType: 'yunnan', // 自定义扩展图表类型
                        aspectScale: 1,
                        itemStyle: {
                            normal: { label: { show: false }, borderColor: '#fff', areaStyle: { color: 'rgba(54,179,116,0.1)' } },
                            emphasis: {
                                label: { show: false },
                                areaColor: '#188950'
                            }
                        },
                        zoom: 1.2,
                        data: this.getSeriesData()
                    }
                })());
                this.setOptions('visualMap', (() => {
                    return {
                        show: false,
                        pieces: this.getColor(),
                        textStyle: {
                            color: '#fff'
                        }
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    position: relative;
    .o-echarts {
        width: 100%;
        height: 80%;
        z-index: 2;
    }
    .back{
        width: 100%;
        height: 80%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    .zero{
        width:15px;
        height:15px;
        // background:rgba(255,255,255,1);
        // border-radius: 50%;
        position: absolute;
        z-index: 99;
        transform: scale(.67);
        transform-origin: 0% 0%;
    }
    .tips{
        display: flex;
        margin-top: 15px;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 45px;
        .tip-box{
            display: flex;
            align-items: center;
            .color{
                width:7px;
                height:7px;
            }
            .text{
                font-size:10px;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:10px;
                margin-left: 4px;
            }
        }
    }
}
</style>
